import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { UseQueryResult } from '@tanstack/react-query'
import React from 'react'

import { Z_INDEX } from '../../../../constants/constants'
import { scrollToTop } from '../../../../lib/helpers/domHelpers'
import { GlobalSearchResultsItem } from '../../../../types/responses/global-search'
import { useGlobalSearch } from '../hooks/useGlobalSearch'
import SearchInput from './SearchBox/components/SearchInput'
import SearchBox from './SearchBox/SearchBox'
import SearchButton from './SearchButton'

interface Props {
  globalSearchQuery: UseQueryResult<GlobalSearchResultsItem>
}

const MobileSearchBox: React.FC<Props> = ({ globalSearchQuery }) => {
  const globalSearch = useGlobalSearch()

  return (
    <>
      <SearchButton />

      {globalSearch.isShowing && (
        <div
          className="bg-white position-fixed start-0 end-0 top-0 bottom-0 px-3 pb-3 overflow-y-scroll"
          style={{
            zIndex: Z_INDEX.globalSearch,
          }}
        >
          <header
            className="bg-white d-flex position-sticky top-0 start-0 end-0 align-items-center border-bottom"
            style={{ gap: '12px', marginBottom: '16px', padding: '12px 0' }}
          >
            <FontAwesomeIcon
              icon={faArrowLeft}
              onClick={() => {
                globalSearch.hide()
                scrollToTop()
              }}
              style={{ fontSize: '16px' }}
            />

            <SearchInput isLoading={globalSearchQuery.isLoading} />
          </header>

          <SearchBox globalSearchQuery={globalSearchQuery} />
        </div>
      )}
    </>
  )
}

export default MobileSearchBox
